export default __webpack_public_path__ + "static/photographers-443b69791d2908a3d677ca17328edd94.jpg";